angular.module( 'acme.view.application.layouts.membership.cards', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.membership.cards.list',
  'acme.view.application.layouts.membership.cards.create',
  'acme.view.application.layouts.membership.cards.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsMembershipCards = {
      name: 'application.layouts.membership.cards',
      url: '/cards',
      abstract: true,
      views: {
        "subview-main": {
          controller: 'LayoutsMembershipCardsController',
          templateUrl: 'views/application/views/layouts/membership/cards/cards.tpl.html'
        }
      },
      data: {
        pageTitle: 'Membership Card Layouts',
        permissions: ['MEMBERSHIP_CARD_LAYOUTS_VIEW']
      }
    };
    $stateProvider
      .state(layoutsMembershipCards);
});
